import { IStatsService } from './stats_service';
import { AppServices } from '../helpers/config_keys';

class DashboardCtrl {
    activeMembers: number
    closedAccounts: number
    balance: number
    monthBalance: number
    contributionBalance: number
    savings: number
    withdrawals: number
    monthCount: number

    static $inject = [AppServices.StatsService];
    constructor(private statsService: IStatsService) {
        this.fetchMembershipStats()
        this.fetchInvestmentStats()
    }

    private fetchMembershipStats() {
        this.statsService.membership().then((res) => {
            if (res.success) {
                this.activeMembers = res.data.active
                this.closedAccounts = res.data.closed
            }
        })
    }

    private fetchInvestmentStats() {
        this.statsService.investments().then((res) => {
            if (res.success) {
                this.balance = res.data.balance
                this.contributionBalance = res.data.contributionBalance
                this.monthBalance = res.data.monthBalance
                this.savings = res.data.savings
                this.withdrawals = res.data.withdrawals
                this.monthCount = res.data.monthCount
            }
        })
    }

}

export { DashboardCtrl }


// WEBPACK FOOTER //
// ./app/main/dashboard_ctrl.ts